import { useEffect, useState } from "react";
import { useTournamentContext } from "../../../../hook/context";
import * as C from "../base/style";
import {
  getTournamentTypeName,
  isDailyType,
  isEventType,
  isGTDType,
} from "../../../../../../utils/tournament-type";
import {
  getPointAndSeedDistributionDetail,
  SeedDistributionDetail,
} from "../../../../../../api/tournament-prize";
import { Const } from "../../../../../../common/const/const";
import {
  getTournamentDetail,
  TournamentResponse,
} from "../../../../../../api/tournament";
import * as S from "./style";
import {
  EditTournamentCheckBox,
  EditTournamentCheckBoxWrapper,
} from "../../style";
import { AddPrize } from "../../../../hook/useEditTournament";
import { dailyAllPrize } from "../../../../../../utils/timer";
import TournamentRemoteControl from "../remote";

const EditTournamentPrize = () => {
  const {
    moneyInChip,
    setMoneyInChip,
    tournamentId,
    isAdditional,
    setIsAdditional,
    additional,
    setAdditional,
    additionalList,
    setAdditionalList,
    tournamentType,
    prizeWay,
    setPrizeWay,
    isDiscountExcluded,
    setIsDiscountExcluded,
    totalDiscount,
  } = useTournamentContext();
  const [data, setData] = useState<TournamentResponse | null>(null);
  const [canAddPrize, setCanAddPrize] = useState(0);
  const [allAddPrize, setAllAddPrize] = useState(0);
  const [sumPrize, setSumPrize] = useState(0);
  const [seedDistribution, setSeedDistribution] = useState<
    SeedDistributionDetail[]
  >([]);
  const [distributionRanks, setDistributionRanks] = useState<number[]>([]);

  useEffect(() => {
    const sumPrize = moneyInChip.reduce((acc, item) => {
      return acc + item.point;
    }, 0);
    setSumPrize(sumPrize);
  }, [moneyInChip]);

  useEffect(() => {
    getDistribution();
  }, [tournamentId]);

  const getDistribution = async () => {
    if (!tournamentId) return;
    const res = await getPointAndSeedDistributionDetail(tournamentId);
    const data = await getTournamentDetail(tournamentId);
    setData(data);
    setSeedDistribution(res.seedDistributionDetails);
    const allRanks = [
      ...res.distributionDetails.map((p) => p.position),
      ...res.seedDistributionDetails.map((s) => s.position),
    ];
    const uniqueRanks = Array.from(new Set(allRanks)).sort((a, b) => a - b);
    setDistributionRanks(uniqueRanks);
  };

  const getOverPrize = () => {
    if (!data) return setCanAddPrize(0);
    const entry = data.entry;
    const allCount =
      data.entryUserCount + data.adOnUserCount + data.reBuyInUserCount;

    if (entry && data.buyIn && allCount > entry) {
      const over = allCount - entry;
      const overPrize = over * data.buyIn * (additional / 100);
      let enterPrize = 0;
      for (let i = 0; i < additionalList.length; i++) {
        enterPrize += additionalList[i].prize * Const.SEED_RATE;
      }
      setAllAddPrize(overPrize / Const.SEED_RATE);
      return setCanAddPrize(
        Math.floor((overPrize - enterPrize) / Const.SEED_RATE)
      );
    } else {
      return setCanAddPrize(0);
    }
  };

  useEffect(() => {
    if (!data) return;
    getOverPrize();
  }, [additional, additionalList, data]);

  // 프라이즈 설정 ==============================================================
  const handleMoneyInChip = (value: number) => {
    const data = [...moneyInChip];
    const add = [...additionalList];
    if (value < 0) {
      if (moneyInChip.length === 1) return;
      data.pop();

      if (isAdditional) {
        add.pop();
        setAdditionalList(add);
      }
    } else {
      data.push({
        rank: moneyInChip.length + 1,
        point: 0,
        subPrize: "",
        isSubPrize: false,
      });

      if (isAdditional) {
        add.push({
          rank: moneyInChip.length + 1,
          prize: 0,
        });
        setAdditionalList(add);
      }
    }
    setMoneyInChip(data);
  };

  const handlePrizeInput = (value: string, index: number) => {
    const rawValue = value.replace(/[^0-9]/g, "");
    const newPoint = parseInt(rawValue, 10) || 0;
    const updatedMoneyInChip = [...moneyInChip];
    updatedMoneyInChip[index] = {
      ...updatedMoneyInChip[index],
      point: newPoint,
    };
    setMoneyInChip(updatedMoneyInChip);
  };

  const handleSubPrizeInput = (value: string, index: number) => {
    const updatedMoneyInChip = [...moneyInChip];
    updatedMoneyInChip[index] = {
      ...updatedMoneyInChip[index],
      subPrize: value,
    };
    setMoneyInChip(updatedMoneyInChip);
  };

  const handleIsSubPrize = (value: boolean, index: number) => {
    const updatedMoneyInChip = [...moneyInChip];
    updatedMoneyInChip[index] = {
      ...updatedMoneyInChip[index],
      isSubPrize: value,
    };
    setMoneyInChip(updatedMoneyInChip);
  };

  // 추가 시상 관련 ===============================================================
  const handleAddPrizeInput = (value: string, index: number) => {
    const rawValue = value.replace(/[^0-9]/g, "");
    const newPoint = parseInt(rawValue, 10) || 0;
    const updatedAdditional = [...additionalList];
    updatedAdditional[index] = {
      ...updatedAdditional[index],
      prize: newPoint,
    };

    let enterPrize = 0;
    for (let i = 0; i < updatedAdditional.length; i++) {
      enterPrize += updatedAdditional[i].prize;
    }

    if (allAddPrize - enterPrize < 0) {
      alert("지급 가능한 값보다 큽니다. ");
      return;
    }

    setAdditionalList(updatedAdditional);
  };

  const checkedAdditional = (checked: boolean) => {
    if (additionalList.some((item) => distributionRanks.includes(item.rank))) {
      alert("이미 추가 시상을 완료하여 해제할 수 없습니다. ");
      return;
    }
    if (checked) {
      const data: AddPrize[] = [];
      for (let i = 0; i < moneyInChip.length; i++) {
        data.push({ rank: i + 1, prize: 0 });
      }
      setAdditionalList(data);
    } else {
      setAdditionalList([]);
    }
    setIsAdditional(checked);
  };

  return (
    <C.EditTournamentBaseWrapper>
      <S.EditTournamentType>
        현재 설정: {getTournamentTypeName(tournamentType)}
      </S.EditTournamentType>
      <C.EditTournamentBaseContent>
        <div className="title">상금 정보</div>
        <C.EditTournamentInputBox>
          <div className="name">상금 종류</div>
          <input
            value={prizeWay}
            onChange={(e) => setPrizeWay(e.target.value)}
            placeholder="매장이용권 / 무료참가권 / 시팅권 / 상금 등 기입해주세요"
          />
        </C.EditTournamentInputBox>
        {isGTDType(tournamentType) || isDailyType(tournamentType) ? (
          <S.EditTournamentPrizeTotal>
            <div className="name">토탈 프라이즈</div>
            <div className="value">
              <div className="text">
                {isDailyType(tournamentType)
                  ? "프라이즈 비율 합계"
                  : "토탈 프라이즈"}
              </div>
              {sumPrize.toLocaleString()}{" "}
              {isDailyType(tournamentType) ? "%" : "RB"}
            </div>
          </S.EditTournamentPrizeTotal>
        ) : null}
      </C.EditTournamentBaseContent>

      <C.EditTournamentBaseContent>
        <div className="title">머니인 정보 설정</div>
        <TournamentRemoteControl
          name="n등까지 제공"
          count={moneyInChip.length}
          unit="등"
          handleCount={(type) => handleMoneyInChip(type === "minus" ? -1 : 1)}
          disabled={seedDistribution.length > 0}
        />
        {moneyInChip.map((m, i) => (
          <S.EditTournamentPrizeSettingItem key={i}>
            {seedDistribution.find((s) => s.position === m.rank) && (
              <div className="overlay">시상완료</div>
            )}
            {!isEventType(tournamentType) && (
              <>
                <EditTournamentCheckBoxWrapper>
                  <EditTournamentCheckBox isMobile={true}>
                    <input
                      type="checkbox"
                      checked={m.isSubPrize}
                      onChange={(e) => {
                        handleIsSubPrize(e.target.checked, i);
                      }}
                    />
                    {m.isSubPrize && (
                      <img
                        src="/image-web/tournament/checked-icon.svg"
                        alt="checked"
                      />
                    )}
                  </EditTournamentCheckBox>
                  <div className="name">{m.rank}등</div>
                </EditTournamentCheckBoxWrapper>
                <C.EditTournamentInputBox $isRow>
                  <input
                    value={
                      m.point === 0 && isDailyType(tournamentType)
                        ? ""
                        : m.point.toLocaleString()
                    }
                    onChange={(e) => handlePrizeInput(e.target.value, i)}
                    placeholder={isDailyType(tournamentType) ? "000" : ""}
                    className={isDailyType(tournamentType) ? "daily" : ""}
                    inputMode="numeric"
                  />
                  {isDailyType(tournamentType) && <span>%</span>}
                </C.EditTournamentInputBox>
              </>
            )}
            <C.EditTournamentInputBox $isRow>
              <input
                placeholder="부상을 기입해주세요. (선택)"
                value={m.subPrize}
                onChange={(e) => handleSubPrizeInput(e.target.value, i)}
              />
            </C.EditTournamentInputBox>
          </S.EditTournamentPrizeSettingItem>
        ))}
      </C.EditTournamentBaseContent>

      {(isGTDType(tournamentType) || isDailyType(tournamentType)) && (
        <C.EditTournamentBaseContent>
          <div className="title">
            {isGTDType(tournamentType) ? "추가 시상" : "할인 제외"}
          </div>
          <EditTournamentCheckBoxWrapper $weight="500">
            <EditTournamentCheckBox isMobile={true}>
              <input
                type="checkbox"
                checked={
                  isGTDType(tournamentType) ? isAdditional : isDiscountExcluded
                }
                onChange={(e) =>
                  isGTDType(tournamentType)
                    ? checkedAdditional(e.target.checked)
                    : setIsDiscountExcluded(e.target.checked)
                }
              />
              {(isGTDType(tournamentType)
                ? isAdditional
                : isDiscountExcluded) && (
                <img
                  src="/image-web/tournament/checked-icon.svg"
                  alt="checked"
                />
              )}
            </EditTournamentCheckBox>
            <div className="name">
              {isGTDType(tournamentType) ? "추가 시상 여부" : "할인 제외 여부"}
            </div>
          </EditTournamentCheckBoxWrapper>

          {isGTDType(tournamentType) && isAdditional && (
            <C.EditTournamentInputBox>
              <div className="name">비율</div>
              <input
                value={additional === 0 ? "" : additional}
                onChange={(e) => setAdditional(+e.target.value)}
                placeholder="00"
                className="daily"
                inputMode="numeric"
              />
              <span>%</span>
            </C.EditTournamentInputBox>
          )}

          {isGTDType(tournamentType) && isAdditional && tournamentId && (
            <S.EditTournamentPrizeInfoSettingWrapper>
              <S.EditTournamentPrizeTotal>
                <div className="name">지급 가능 프라이즈</div>
                <div className="value">{canAddPrize.toLocaleString()}</div>
              </S.EditTournamentPrizeTotal>
              {additionalList.map((m, i) => (
                <S.EditTournamentPrizeSettingItem $isAdd key={i}>
                  {seedDistribution.find((s) => s.position === m.rank) && (
                    <div className="overlay" />
                  )}
                  <C.EditTournamentInputBox $isRow>
                    <div className="name">{m.rank}등</div>
                    <input
                      value={m.prize === 0 ? "" : m.prize.toLocaleString()}
                      onChange={(e) => handleAddPrizeInput(e.target.value, i)}
                      placeholder={isDailyType(tournamentType) ? "000" : ""}
                      className="daily"
                      tabIndex={-1}
                      inputMode="numeric"
                    />
                    <span>RB</span>
                  </C.EditTournamentInputBox>
                </S.EditTournamentPrizeSettingItem>
              ))}
            </S.EditTournamentPrizeInfoSettingWrapper>
          )}

          {isDailyType(tournamentType) && isDiscountExcluded && data && (
            <S.EditTournamentPrizeDiscount>
              <div className="item">
                <div className="name">총 금액</div>
                <div className="value">
                  {dailyAllPrize(data).toLocaleString()}
                </div>
              </div>
              <div className="item">
                <div className="name">할인 금액</div>
                <div className="value">-{totalDiscount.toLocaleString()}</div>
              </div>
              <div className="line" />
              <div className="item">
                <div className="name">적용 금액</div>
                <div className="value">
                  {(dailyAllPrize(data) - totalDiscount).toLocaleString()}
                </div>
              </div>
            </S.EditTournamentPrizeDiscount>
          )}
        </C.EditTournamentBaseContent>
      )}
    </C.EditTournamentBaseWrapper>
  );
};

export default EditTournamentPrize;
